import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { History, Location } from 'history';
import { routes } from 'utils/routeHelper';
import { loadAuthToken } from 'utils/tokenStorage';
import { clearPaginateStorage } from 'utils/paginateStorage';
import Menu from './Menu';
import './styles.scss';

interface IStateProps {
  history: History;
  location: Location;
  token: Nullable<string>;
  currentUserName: string;
  currentUserRoles: string[];
  currentUserScopes: string[];
}

type Props = IStateProps;

const routesWithoutHeader = [
  routes.LOG_IN,
  routes.MFA_VALIDATION,
  routes.FORGOT_PASSWORD,
  routes.CLINICIAN_SETUP_ACCOUNT,
  routes.SETUP_ACCOUNT,
  routes.RESET_PASSWORD,
  routes.INVALID_PATH,
  routes.MAINTENANCE,
  routes.WHOOPS,
];

const Header = (props: Props) => {
  const {
    token,
    currentUserName,
    currentUserRoles,
    currentUserScopes,
    location,
  } = props;
  if (routesWithoutHeader.includes(location.pathname)) return null;

  return (
    <header>
      <div styleName="container" data-testid="header">
        <div styleName="wrapper">
          <div styleName="left">
            <Link
              title="Return Home"
              to={routes.ROOT}
              onClick={() => clearPaginateStorage()}
              styleName={`pear-logo ${
                location.pathname === routes.MFA_REGISTER ? 'non-clickable' : ''
              }`}
              data-testid="pear-logo"
            />
          </div>
          {token && (
            <div>
              <span
                data-testid="current-name"
                styleName="current-name"
                aria-label="Prescriber Name"
              >
                {currentUserName}
              </span>
              <Menu
                currentUserRoles={currentUserRoles}
                currentUserScopes={currentUserScopes}
                location={location}
              />
            </div>
          )}
          {location.pathname !== routes.MFA_REGISTER && !token && (
            <Link
              to={routes.ROOT}
              styleName="login-btn"
              data-testid="login-btn"
            >
              LOG IN
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = ({
  authenticate: { token, profile },
}: {
  authenticate: IAuthenticateState;
}) => ({
  token: token || loadAuthToken(),
  currentUserName: profile ? `${profile.firstName} ${profile.lastName}` : '',
  currentUserRoles: profile?.roles ?? [],
  currentUserScopes: profile?.scopes ?? [],
});

export default connect(mapStateToProps)(Header);
